import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { PermissionService } from '../api/permission.api.service';
import { PermissionModel } from '../../models/user/permission.model';
import { List } from 'immutable';
import { AlertService } from '../alert.service';
import { BaseDataStore } from './base-data.store';
import { map } from 'rxjs/operators';
import { PermissionService as PermissionCheckService } from '../permission.service';
import * as PermissionConstants from '../../modules/catch-core/data/constants/permission.constants';
@Injectable({
  providedIn: 'root',
})
export class PermissionStore extends BaseDataStore {
  private _permissions: BehaviorSubject<List<PermissionModel>> = new BehaviorSubject(List<PermissionModel>([]));
  public $permissions: Observable<List<PermissionModel>> = this._permissions.asObservable();

  constructor(
    private permissionService: PermissionService,
    private alertService: AlertService,
    private permissionCheckService: PermissionCheckService,
  ) {
    super();
    //this.loadInitialData();
    this.behaviorSubjectList.push(this._permissions);
  }

  // get permissions() {
  //   return this._permissions.asObservable();
  // }

  get $firstPermission(): Observable<PermissionModel | undefined> {
    return this.$permissions.pipe(
      map((permissions: List<PermissionModel>) => {
        if (permissions.count() > 0) {
          const permission = permissions.get(0);
          return permission;
        }
        return undefined; // Explicitly return undefined if no permissions are present
      }),
    );
  }

  public loadInitialData(): void {
    if (this.subscribers.permissionSubscription) {
      this.subscribers.permissionSubscription.unsubscribe();
    }

    if (!this.permissionCheckService.hasPermission(PermissionConstants.PERMISSION_READ)) {
      // Non-admin roles don't hold permission:read, so GET api/permissions would 403 -
      // see api/docs/permissions/permission-v3.md.
      this._permissions.next(List([]));
      return;
    }

    this.subscribers.permissionSubscription = this.permissionService.getPermissions().subscribe(
      (res: any) => {
        const permissions = (<Object[]>res).map((permission: any) => new PermissionModel(permission));

        this._permissions.next(List(permissions));
      },
      (err: any) => {
        console.log('Error retrieving Permissions');
        console.log(err);
        this.alertService.showError('Error retrieving Permissions!');
      },
    );
  }

  public $updatePermission(permission: PermissionModel): Observable<Boolean | undefined> {
    // Make a call to save data
    const httpResponse = this.permissionService.updatePermission(permission);

    return httpResponse.pipe(
      map(
        (res: any) => {
          if (res) {
            this.loadInitialData();
            return true;
          }
        },
        (err: any) => {
          console.log(err);
          this.alertService.showError('Saving permission failed!');
          return false;
        },
      ),
    );
  }

  // Permissions are created and deleted only via DB migration - the backend no longer exposes
  // create/delete endpoints, for any role including sysadmin.
}
